/* tslint:disable */
/* eslint-disable */

/**
 * 401130000 = Ausschreibungsname (Ausschreibungsname)
 * 
 * 401130001 = Forderprogramm (Förderprogramm)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum GlobalEnumsAceSortierungausschreibungskacheln {
 Ausschreibungsname = 401130000,
 Forderprogramm = 401130001
}

marker([
    "Enum.GlobalEnumsAceSortierungausschreibungskacheln.Ausschreibungsname",
    "Enum.GlobalEnumsAceSortierungausschreibungskacheln.Forderprogramm"
]);

export namespace GlobalEnumsAceSortierungausschreibungskacheln
{
    class DataSets
    {
        static GlobalEnumsAceSortierungausschreibungskachelnDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("Ausschreibungsname", 401130000, "Ausschreibungsname"),
            new EnumValue("Forderprogramm", 401130001, "Förderprogramm"),
        )
    }

    export function getAsDataset() {
        return DataSets.GlobalEnumsAceSortierungausschreibungskachelnDataSet;
    }
}
